var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgSocialTelegram = function SvgSocialTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "#252525"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Footer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -31.5,
    y: -540.5,
    width: 2629,
    height: 1067,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Device=Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 1004.36,
    transform: "translate(-16 -525)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo 1",
    clipPath: "url(#clip0_275_4599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.360016C0.895431 0.360016 0 1.25545 0 2.36002V22.36C0 23.4646 0.89543 24.36 2 24.36H22C23.1046 24.36 24 23.4646 24 22.36V2.36002C24 1.25545 23.1046 0.360016 22 0.360016H2ZM12.6852 8.52171C11.3019 9.09708 8.5372 10.288 4.39113 12.0943C3.71787 12.3621 3.36519 12.624 3.33309 12.8801C3.27883 13.3129 3.82084 13.4833 4.55893 13.7154C4.65933 13.747 4.76335 13.7797 4.87 13.8144C5.59616 14.0504 6.57298 14.3266 7.08078 14.3375C7.54141 14.3475 8.05553 14.1576 8.62313 13.7678C12.4969 11.1529 14.4966 9.8312 14.6221 9.80271C14.7107 9.78261 14.8334 9.75733 14.9166 9.83124C14.9998 9.90516 14.9916 10.0451 14.9828 10.0827C14.9291 10.3116 12.8015 12.2896 11.7004 13.3132C11.3572 13.6324 11.1137 13.8587 11.0639 13.9104C10.9524 14.0262 10.8388 14.1358 10.7296 14.241C10.055 14.8914 9.54908 15.3791 10.7576 16.1755C11.3384 16.5582 11.8031 16.8747 12.2667 17.1904C12.7731 17.5352 13.2781 17.8792 13.9315 18.3075C14.098 18.4166 14.257 18.53 14.4119 18.6404C15.0011 19.0604 15.5305 19.4379 16.1845 19.3777C16.5646 19.3427 16.9571 18.9853 17.1565 17.9196C17.6277 15.4008 18.5538 9.94337 18.7678 7.6945C18.7866 7.49747 18.763 7.24532 18.744 7.13462C18.7251 7.02393 18.6855 6.86622 18.5416 6.74947C18.3712 6.6112 18.1082 6.58204 17.9905 6.58412C17.4556 6.59354 16.6349 6.87891 12.6852 8.52171Z",
    fill: "white"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_4599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.360016)"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgSocialTelegram);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/social-telegram.fc6851cb67118c7309cbf6bb86064c9f.svg";